/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectDailyTasksQuery } from '../../models/get-project-daily-tasks-query';
import { GetProjectDailyTasksQueryResult } from '../../models/get-project-daily-tasks-query-result';

export interface ApiProjectDailyTasksGetProjectDailyTasksPost$Plain$Params {
      body?: GetProjectDailyTasksQuery
}

export function apiProjectDailyTasksGetProjectDailyTasksPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTasksGetProjectDailyTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTasksQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTasksGetProjectDailyTasksPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectDailyTasksQueryResult>;
    })
  );
}

apiProjectDailyTasksGetProjectDailyTasksPost$Plain.PATH = '/api/ProjectDailyTasks/GetProjectDailyTasks';
